import { useEffect } from 'react';
import { MButton, MInput, MRadio, MSelect, MTextArea } from '@Components/Base';

import { Col, Flex, Form, Row } from 'antd';

import { FormikProps } from 'formik';
import { Option } from '@Components/types/options';
import MUpload from '@Components/Base/Upload/Upload';

import { MaterialRequisitionDocumentRequest } from '@Types/api/form';
import { RcCustomRequestOptions } from '@Components/types/UploadType';
import { Attachment } from '@Components/types/Attachment';

import styles from './modal-content.module.css';
import { statusOptions, сonfidentialOptions } from './constants';

interface ModalContentProps {
  onDisableSaveButton: (value: boolean) => void;
  formik: FormikProps<MaterialRequisitionDocumentRequest>;
  documentTypes: Option[];
  filePath: string;
  uploadedFile?: Attachment;
  isEditMode?: boolean;
  isDisableSaveButton: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
  handleSaveDocument: () => void;
  onFileRequest: (options: RcCustomRequestOptions) => void;
  onFileRemove: () => void;
  onUploadedFileRemove?: (value: boolean | undefined) => void;
}

const ModalContent: React.FC<ModalContentProps> = ({
  formik,
  filePath,
  handleSubmit,
  handleSaveDocument,
  documentTypes,
  onFileRemove,
  onFileRequest,
  uploadedFile,
  onUploadedFileRemove,
  isDisableSaveButton,
  isEditMode = false,
  onDisableSaveButton,
}) => {
  const confidentialValue = formik.values.isConfidential;

  const docTypeValue = formik.values.procDocTypeId;

  const docNameValue = formik.values.docName;

  const docDesValue = formik.values.docDesc;

  const statusValue = formik.values.deleteFlag;

  useEffect(() => {
    let disableSaveButton = true;

    if (
      formik.values.docName &&
      formik.values.docDesc &&
      formik.values.procDocTypeId &&
      (filePath || formik.values.filePath)
    ) {
      disableSaveButton = false;
    }

    onDisableSaveButton(disableSaveButton);
  }, [formik.values, filePath]);

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Row className={styles.container}>
        <Col span={24} className={styles.col}>
          <Form.Item label="Confidential">
            <Flex>
              {сonfidentialOptions.map((option) => (
                <MRadio
                  className={styles.radio}
                  key={option.label}
                  id={option.label}
                  value={option.value}
                  name="confidential"
                  labelText={option.label}
                  onChange={(event) =>
                    formik.setFieldValue('isConfidential', event.target.value)
                  }
                  checked={Number(confidentialValue) === Number(option.value)}
                />
              ))}
            </Flex>
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Type">
            <MSelect
              labeloption="Document Type"
              value={documentTypes[docTypeValue - 1]}
              options={documentTypes}
              onChange={(value) => {
                formik.setFieldValue('procDocTypeId', Number(value));
              }}
              placeholder="Select Document Type"
              disabled={isEditMode}
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Name">
            <MInput
              placeholder="Insert document name"
              value={docNameValue}
              onChange={(event) => {
                formik.setFieldValue('docName', event.target.value);
              }}
              disabled={isEditMode}
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Description">
            <MTextArea
              name="docDesc"
              value={docDesValue}
              onChange={formik.handleChange}
              rows={4}
              showCount
              maxLength={100}
              placeholder="Description goes here"
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Status">
            <Flex>
              {statusOptions.map((option) => {
                return (
                  <MRadio
                    className={styles.radio}
                    key={option.label}
                    id={option.label}
                    value={option.value}
                    name="status"
                    labelText={option.label}
                    onChange={(event) =>
                      formik.setFieldValue(
                        'deleteFlag',
                        Number(event.target.value)
                      )
                    }
                    checked={Number(statusValue) === Number(option.value)}
                  />
                );
              })}
            </Flex>
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Attachement">
            <MUpload
              onFileRequest={onFileRequest}
              onFileRemove={onFileRemove}
              uploadedFile={uploadedFile}
              onUploadedFileRemove={onUploadedFileRemove}
              showSwitcher={false}
            />
          </Form.Item>
        </Col>
        {!isEditMode && (
          <Col span={24} className={styles.col}>
            <MButton
              onClick={handleSaveDocument}
              className={styles.buttonSave}
              type="secondary"
              disabled={isDisableSaveButton}
            >
              Save & Add Another
            </MButton>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default ModalContent;
